module.exports = __webpack_public_path__ + "static/media/yellowCurveConcaveStreamlined.3c5662b7.svg";